import React from 'react';

import Button from '@atlaskit/button/new';
import EditorRemoveIcon from '@atlaskit/icon/core/delete';

export const DeleteButton = ({ onClick }: { onClick: () => void }) => (
	<Button
		appearance="subtle"
		iconBefore={(iconProps) => <EditorRemoveIcon {...iconProps} label="clear gate override" />}
		onClick={onClick}
	>
		Delete
	</Button>
);
